module.exports = __webpack_public_path__ + "assets/cynergy_app_dashboard.55b79ef8.svg";